import { useCallback, useState, type KeyboardEvent } from "react";

/**
 * 处理包含附件时需要确认的发送逻辑
 * @param hasAttachments 是否有附件
 * @param onSend 发送消息的回调函数
 */
export function useConfirmBeforeSend(
  hasAttachments: boolean,
  onSend: () => void | Promise<void>
) {
  const [confirmOpen, setConfirmOpen] = useState(false);

  // 处理键盘快捷键提交
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "Enter") {
        e.preventDefault();
        // 如果有附件，显示确认弹窗；否则直接发送
        if (hasAttachments) {
          if (confirmOpen) {
            setConfirmOpen(false);
            onSend();
          } else {
            setConfirmOpen(true);
          }
        } else {
          onSend();
        }
      }
    },
    [hasAttachments, onSend]
  );

  // 确认后的发送处理
  const handleConfirmSend = useCallback(() => {
    setConfirmOpen(false);
    onSend();
  }, [onSend]);

  return {
    confirmOpen,
    setConfirmOpen,
    handleKeyDown,
    handleConfirmSend,
  };
}
